export default "__VITE_ASSET__OEMlNasq__"